import client from "./Client";

const getAuthorizations = () => {
  return client.get(`/schools/authorizations`);
};

const getSubscriptionPackageDetails = (subscriptionPackageId) => {
  return client.get(`/subscription-package/${subscriptionPackageId}/details`);
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAuthorizations,
  getSubscriptionPackageDetails
};
